export default __webpack_public_path__ + "static/media/airport_100px.816690c3.svg";